import { GetPersonFingerprintModel } from "@core/model/query-model-person-fingerprint";
import { personFingerprintFormDefault } from "./form.default";
import { PersonFingerprintFormSchema } from "./form.rule";

export const useFormDefaultPersonFingerprint = () => {
  const getDefault = (
    cachedValue: GetPersonFingerprintModel | undefined,
    userCode?: string
  ) => {
    return !cachedValue
      ? ({
          ...personFingerprintFormDefault,
          userCode: userCode || "",
        } as PersonFingerprintFormSchema)
      : ({
          code: cachedValue.code,
          userCode: cachedValue.user_code,
          fingerprintId: cachedValue.fingerprint_id,
          deviceId: cachedValue.device_id || "",
        } as PersonFingerprintFormSchema);
  };

  return {
    getDefault,
  };
};
